export default function TableOrderConfirmation({
  tableLabel,
  orderStatus,
  acceptedCount,
  onBackToMenu,
  onViewTableOrder,
}) {
  return (
    <div className="ck-root">
      <div style={{ maxWidth: 560, margin: "0 auto" }}>
        <div className="ck-card">
          <div className="ck-success">
            <div className="ck-success-icon"><i className="bi bi-check2-circle" /></div>
            <p className="ck-success-title">Pedido enviado a Mesa {tableLabel}</p>
            <p className="ck-success-sub">
              El restaurante recibio tu pedido. El pago se realiza en el restaurante.
            </p>
            <div className="alert alert-success py-2">
              Pago en el restaurante
            </div>
            <p className="ck-success-id">
              Estado: {orderStatus || "recibido"} - {acceptedCount} producto{acceptedCount === 1 ? "" : "s"} aceptado{acceptedCount === 1 ? "" : "s"}
            </p>
            <div className="ck-actions" style={{ justifyContent: "center", marginTop: "1.5rem" }}>
              <button className="ck-btn-primary" onClick={onBackToMenu} type="button">
                Volver al menu <i className="bi bi-arrow-right" />
              </button>
              <button className="ck-btn-back" onClick={onViewTableOrder} type="button">
                Ver pedido de la mesa
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
